module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00035-fs8.57b55d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00035-fs8.png
// module id = 188
// module chunks = 0